import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { RuleSet } from '../models/rule-set.model';

export interface RuleSetListResponse {
  status: number;
  message: string;
  data: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    data: RuleSet[];
  };
}

export interface SingleRuleSetResponse {
  status: number;
  message: string;
  data: RuleSet;
}

export interface MultipleRuleSetsResponse {
  status: number;
  message: string;
  data: RuleSet[];
}

export interface RuleSetWriteResponse {
  status: number;
  message: string;
  data: RuleSet;
}

export interface IRuleSetService {
  getRuleSetList(params: Record<string, string | number | boolean>): Observable<RuleSetListResponse>;
  getMultipleRuleSets(params: Record<string, string | string[]>): Observable<MultipleRuleSetsResponse>;
  getOneByName(params: Record<string, string>): Observable<SingleRuleSetResponse>;
  getRuleSetDetails(id: string): Observable<SingleRuleSetResponse>;
  createRuleSet(formData: Partial<RuleSet>): Observable<RuleSetWriteResponse>;
  updateRuleSet(id: string, formData: Partial<RuleSet>): Observable<RuleSetWriteResponse>;
  updateRuleSetStatus(id: string, status: number): Observable<RuleSetWriteResponse>;
  deleteRuleSet(id: string): Observable<RuleSetWriteResponse>;
}

export const RULE_SET_SERVICE = new InjectionToken<IRuleSetService>('RULE_SET_SERVICE');
